/**
 * Devolve o main thread ao browser por um tick, o mais barato possível.
 *
 * `requestIdleCallback` parece a escolha natural, mas durante um sync o main thread nunca fica
 * ocioso — então ele sempre cai no `timeout`, cobrando esse tempo cheio a cada lote. `setTimeout(0)`
 * tem o clamp de ~4ms. `MessageChannel` agenda uma macrotarefa imediata: a UI respira entre os
 * lotes sem que a espera vire o custo.
 */
export const yieldToMain = (): Promise<void> => {
  if (typeof MessageChannel === 'undefined') {
    return new Promise((resolve) => setTimeout(resolve, 0));
  }

  return new Promise((resolve) => {
    const canal = new MessageChannel();
    canal.port1.onmessage = () => {
      canal.port1.close();
      resolve();
    };
    canal.port2.postMessage(null);
  });
};
